<div
  class="figure-ordering-overlay"
  role="button"
  tabindex="0"
  aria-label="Close figure ordering"
  (click)="onCancel()"
  (keydown.escape)="onCancel()"
  (keydown.enter)="onCancel()"
  (keydown.space)="onCancel()">
  <div
    class="figure-ordering-popup"
    role="dialog"
    aria-modal="true"
    aria-labelledby="figure-ordering-title"
    tabindex="-1"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()">
    <h3 id="figure-ordering-title" class="figure-ordering-title">Arrange Figure Ordering</h3>
    <ng-container>
      <p class="figure-ordering-hint">
        Drag a sample into any figure to reassign it. Drop order inside a figure controls drawing order.
        Use the + buttons to add a new figure, then drag samples into it.
      </p>
      <div class="bucket-row" cdkDropListGroup>
        @for (figure of figures; track figure; let i = $index; let last = $last) {
          <div class="bucket-card">
            <div class="bucket-header">
              <span class="bucket-header-label">Figure {{ i + 1 }}</span>
              <button
                type="button"
                class="remove-figure-button"
                aria-label="Remove this figure"
                title="Remove this figure"
                [disabled]="figure.precastFigureSamples.length > 0"
                (click)="removeFigure(i)">
                &minus;
              </button>
            </div>
            <input
              type="text"
              class="legend-header-display"
              readonly
              [value]="figure.legendHeader || ''"
              placeholder="No legend header" />
              <div
                cdkDropList
                [cdkDropListData]="figure.precastFigureSamples"
                (cdkDropListDropped)="drop($event)"
                class="sample-list">
                @for (sample of figure.precastFigureSamples; track sample) {
                  <div
                    cdkDrag
                    class="sample-box">
                    {{ sample.sampleLabel }}
                  </div>
                }
                @if (!figure.precastFigureSamples.length) {
                  <div class="bucket-empty">
                    Drop samples here
                  </div>
                }
              </div>
              <button
                mat-stroked-button
                type="button"
                class="edit-legend-header-button"
                (click)="openLegendHeaderModal(i)">
                Edit Figure Legend Header
              </button>
            </div>
            <button
              type="button"
              class="add-figure-button"
              aria-label="Add a figure here"
              title="Add a figure"
              (click)="addFigureAfter(i)">
              +
            </button>
          }
          @if (!figures.length) {
            <div class="bucket-empty-state">
              No figures with curves to arrange.
            </div>
          }
        </div>
        <div class="figure-ordering-actions">
          <button mat-raised-button (click)="onCancel()">Cancel</button>
          <button mat-raised-button color="primary" class="button-primary" (click)="onSave()">Save Figures</button>
        </div>
      </ng-container>

      @if (legendHeaderModalOpen) {
        <div
          class="legend-header-overlay"
          role="button"
          tabindex="0"
          aria-label="Close edit figure legend header"
          (click)="closeLegendHeaderModal()"
          (keydown.escape)="closeLegendHeaderModal()"
          (keydown.enter)="closeLegendHeaderModal()"
          (keydown.space)="closeLegendHeaderModal()">
          <div
            class="legend-header-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="legend-header-title"
            tabindex="-1"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()">
            <h3 id="legend-header-title" class="figure-ordering-title">
              Edit Figure {{ activeLegendIndex !== null ? activeLegendIndex + 1 : '' }} Legend Header
            </h3>
            <input
              type="text"
              class="legend-header-textbox"
              [(ngModel)]="legendHeaderDraft"
              placeholder="Enter figure legend header" />
              <div class="figure-ordering-actions">
                <button mat-raised-button (click)="closeLegendHeaderModal()">Cancel</button>
                <button
                  mat-raised-button
                  color="primary"
                  class="button-primary"
                  (click)="saveLegendHeader()">
                  Save
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
